export default {
  field_empty: "This field cannot be empty.",
  password: "Password",
  error_char_blanks: "Blank values are not allowed",
  error_number_min: "Value must be at least {min}",
  error_number_max: "Value must be at most {max}",
  error_number_between: "Value must be between {min} and {max}",
  error_number_whole: "Only whole numbers are allowed",
  error_number_precision: "Precision should be at most {decimals} numbers",
}
